import { StatusSelector } from './components/StatusSelector';
import { ProjectStageSelector } from './components/ProjectStageSelector';
import { WIZARD_DEV_TIMES } from './constants';
import { inputStyle } from './wizardStyles';
import { haptic } from '../../utils/haptic';

export interface Step4Data {
  project_status: string;
  statuses: string[];
  dev_time: string;
  price: string;
  potential: string;
  show_contacts: boolean;
  site_url: string;
  demo_url: string;
  github_url: string;
  tg_url: string;
}

export function WizardStep4({
  data,
  onPatch,
}: {
  data: Step4Data;
  onPatch: (patch: Partial<Step4Data>) => void;
}) {
  return (
    <div style={{ paddingBottom: 100 }}>
      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', fontSize: '0.75rem', color: 'rgba(255,255,255,0.5)', marginBottom: 8 }}>
          Стадия проекта <span style={{ color: 'var(--accent2, #c084fc)' }}>*</span>
        </label>
        <ProjectStageSelector
          selected={data.project_status}
          onChange={(project_status) => onPatch({ project_status })}
        />
      </div>
      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', fontSize: '0.75rem', color: 'rgba(255,255,255,0.5)', marginBottom: 8 }}>
          Плашки карточки (до 2) <span style={{ fontSize: '0.7rem', opacity: 0.6 }}>(необязательно)</span>
        </label>
        <StatusSelector selected={data.statuses} onChange={(statuses) => onPatch({ statuses })} />
      </div>
      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', fontSize: '0.75rem', color: 'rgba(255,255,255,0.5)', marginBottom: 8 }}>
          Время разработки <span style={{ color: 'var(--accent2, #c084fc)' }}>*</span>
        </label>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          {WIZARD_DEV_TIMES.map((opt) => (
            <button
              key={opt.value}
              type="button"
              style={{
                padding: '8px 12px',
                borderRadius: 8,
                border: `1px solid ${data.dev_time === opt.value ? 'rgba(180,100,255,0.35)' : 'rgba(255,255,255,0.07)'}`,
                background: data.dev_time === opt.value ? 'rgba(120,80,255,0.15)' : 'rgba(255,255,255,0.04)',
                color: data.dev_time === opt.value ? 'var(--accent2, #c084fc)' : 'rgba(255,255,255,0.8)',
                fontSize: '0.8125rem',
                cursor: 'pointer',
              }}
              onClick={() => { haptic.select(); onPatch({ dev_time: opt.value }); }}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>
      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', fontSize: '0.75rem', color: 'rgba(255,255,255,0.5)', marginBottom: 6 }}>
          Стоимость (₽, по желанию)
        </label>
        <input
          type="text"
          inputMode="numeric"
          value={data.price}
          onChange={(e) => onPatch({ price: e.target.value })}
          placeholder="например 15 000 или договорная"
          style={inputStyle}
          onFocus={(e) => (e.target.style.borderColor = 'rgba(180,100,255,0.35)')}
          onBlur={(e) => (e.target.style.borderColor = 'rgba(255,255,255,0.07)')}
        />
      </div>
      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', fontSize: '0.75rem', color: 'rgba(255,255,255,0.5)', marginBottom: 6 }}>
          Потенциал монетизации <span style={{ fontSize: '0.7rem', opacity: 0.6 }}>(необязательно)</span>
        </label>
        <textarea
          value={data.potential}
          onChange={(e) => onPatch({ potential: e.target.value })}
          placeholder="Например: подписка от 5k/мес, пилоты, консультации"
          rows={3}
          style={{ ...inputStyle, minHeight: 88, resize: 'vertical' }}
          onFocus={(e) => (e.target.style.borderColor = 'rgba(180,100,255,0.35)')}
          onBlur={(e) => (e.target.style.borderColor = 'rgba(255,255,255,0.07)')}
        />
      </div>
      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', fontSize: '0.75rem', color: 'rgba(255,255,255,0.5)', marginBottom: 6 }}>
          Ссылки проекта <span style={{ fontSize: '0.7rem', opacity: 0.6 }}>(необязательно)</span>
        </label>
        {[
          { key: 'site_url' as const, type: 'url', placeholder: 'Сайт / лендинг (https://...)' },
          { key: 'demo_url' as const, type: 'url', placeholder: 'Демо (https://...)' },
          { key: 'github_url' as const, type: 'text', placeholder: 'GitHub / репозиторий (owner/repo или https://github.com/...)' },
          { key: 'tg_url' as const, type: 'url', placeholder: 'Telegram-канал / бот / группа (https://t.me/...)' },
        ].map(({ key, type, placeholder }) => (
          <input
            key={key}
            type={type}
            value={data[key]}
            onChange={(e) => onPatch({ [key]: e.target.value })}
            placeholder={placeholder}
            style={{ ...inputStyle, marginBottom: 6 }}
            onFocus={(e) => (e.target.style.borderColor = 'rgba(180,100,255,0.35)')}
            onBlur={(e) => (e.target.style.borderColor = 'rgba(255,255,255,0.07)')}
          />
        ))}
      </div>
      <label style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 12 }}>
        <input
          type="checkbox"
          checked={data.show_contacts}
          onChange={(e) => onPatch({ show_contacts: e.target.checked })}
          style={{ width: 18, height: 18 }}
        />
        <span style={{ fontSize: '0.875rem', color: 'rgba(255,255,255,0.8)' }}>Показывать контакты в посте</span>
      </label>
    </div>
  );
}
